import { Close } from '@project-lary/react-material-symbols';
import { ChevronBackward } from '@project-lary/react-material-symbols';
import IconComponent from 'gcs-common/components/Icon/Icon';
import { ICON, ICON_COLOR, ICON_TRANSFORM } from 'gcs-common/constants/IconConstants';
import { RIGHT_BAR_TABS } from 'gcs-common/constants/uiFlags';
import IconButton from 'gcs-common/design-system/ui/icon-button';
import { SidebarHeader } from 'gcs-common/design-system/ui/sidebar';
import { getChannelMemberCount, getIsSalesSpaceChannelType } from 'gcs-common/slices/channel/channelSelectors';
import { getIsAgent } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { getRightBarTab } from 'gcs-common/slices/uiState/uiStateSelectors';
import { setRightBarTab } from 'gcs-common/slices/uiState/uiStateSlice';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './styles.module.scss';

const ProfileHeader = ({ title = '' }) => {
  const dispatch = useDispatch();

  const onClose = useCallback(() => {
    dispatch(setRightBarTab({ rightBarTab: RIGHT_BAR_TABS.TOOLS }));
  }, [dispatch]);

  const onGoBack = () => {
    dispatch(setRightBarTab({ rightBarTab: RIGHT_BAR_TABS.CHANNEL_DETAILS }));
  };
  return (
    <SidebarHeader>
      <div className={styles.headerMemberButtons}>
        <button>
          <IconButton
            Icon={ChevronBackward}
            iconSize="size-6"
            className="cursor-pointer"
            size="m"
            variant="ghost_neutral"
            onClick={onGoBack}
          />
        </button>
      </div>

      <div className={styles.headerMemberDetails}>{title}</div>
      <div className={styles.headerMemberButtons}>
        <button>
          <IconButton
            Icon={Close}
            iconSize="size-6"
            className="cursor-pointer"
            size="m"
            variant="ghost_neutral"
            onClick={onClose}
          />
        </button>
      </div>
    </SidebarHeader>
  );
};

ProfileHeader.propTypes = {
  title: PropTypes.string,
  channelId: PropTypes.string,
};

export default ProfileHeader;
